import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'Zero-Knowledge Encryption',
      description: 'AES-256-GCM client-side encryption'
    },
    {
      icon: 'Lock',
      title: 'SSL/TLS Protected',
      description: 'End-to-end encrypted connection'
    },
    {
      icon: 'Fingerprint',
      title: 'WebAuthn Passkeys',
      description: 'FIDO2 biometric authentication'
    },
    {
      icon: 'Eye',
      title: 'Privacy First',
      description: 'We never see your passwords'
    }
  ];

  const trustBadges = [
    {
      name: 'SOC 2 Type II',
      icon: 'Award',
      color: 'text-success'
    },
    {
      name: 'ISO 27001',
      icon: 'CheckCircle',
      color: 'text-primary'
    },
    {
      name: 'GDPR Compliant',
      icon: 'Shield',
      color: 'text-accent'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="bg-muted/30 rounded-lg p-6">
        <h3 className="text-lg font-medium text-foreground mb-4 text-center">
          Enterprise-Grade Security
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {securityFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-foreground">
                  {feature?.title}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Trust Badges */}
      <div className="text-center">
        <p className="text-sm text-muted-foreground mb-4">
          Trusted by 10,000+ organizations worldwide
        </p>
        <div className="flex items-center justify-center space-x-6">
          {trustBadges?.map((badge, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name={badge?.icon} size={16} className={badge?.color} />
              <span className="text-xs font-medium text-muted-foreground">
                {badge?.name}
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* SSL Certificate Info */}
      <div className="bg-success/10 border border-success/20 rounded-lg p-4">
        <div className="flex items-center space-x-3">
          <Icon name="Lock" size={16} className="text-success" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-success">
              Secure Connection Verified
            </p>
            <p className="text-xs text-success/80 mt-1">
              256-bit SSL encryption • Certificate valid until Dec 2025
            </p>
          </div>
          <Icon name="CheckCircle" size={16} className="text-success" />
        </div>
      </div>
      {/* Privacy Notice */}
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          By signing in, you agree to our{' '}
          <button className="text-accent hover:text-accent/80 transition-smooth">
            Terms of Service
          </button>{' '}
          and{' '}
          <button className="text-accent hover:text-accent/80 transition-smooth">
            Privacy Policy
          </button>
        </p>
      </div>
    </div>
  );
};

export default SecurityIndicators;